{
    "ModalTitleAdd": "Add New Report",
    "ModalTitleModify": "Modify Report",
    "ModalTitleDateTime": "Date/Time Range",
    "TabnameReport": "Report",
    "TabnameFilter": "Filter",
    "TabnameOther": "Other",
    "TabnameFields": "Fields",
    "TabnameDashboard": "Layout",
    "TabnameSlakpi": "SLA/KPI",
    "TabnameAlarms": "Alarms",
    "TabnameScheduling": "Scheduling",
    "TabnameAcdCodes": "Codes",
    "TabnameFinancial": "Financial",
    "TabnameSettings": "Settings",
    "TabnamePrint": "Print",
    "TabnameAdvanced": "Advanced",
    "ReporttypelabelNolistitems": "No current list items with that name.",
    "NAME": "ConfigureReport",
    "ConfigureReport_ButtonHelpLabel": "Help?",
    "ConfigureReport_ButtonSubmitLabel": "OK",
    "ConfigureReport_ButtonCancelLabel": "Cancel",
    "ConfigureReport_PromptMessage": "Are you sure you want to close this window? All modified configurations will be lost when closed.",
    "ConfigureReport_PromptConfirm": "Yes",
    "ConfigureReport_PromptCancel": "Cancel",
    "ConfigureReport_Basic": "Basic",
    "ConfigureReport_Advanced": "Advanced"
}